import React from "react";
import { BlockView } from "common/views/block/BlockView.view";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as pageSizeActions from 'core/actions/pageSizeActions';
import Label from "core/components/label/Label";
import IOption from "common/models/IOption";
import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import { IPanelProps } from 'core/decorators/Panel';

const pageSizeOptions:Array<IOption<number>> = [
    {value: 10, label: "10"},
    {value: 20, label: "20"},
    {value: 50, label: "50"},
    {value: 100, label: "100"},
];
export interface IStateProps {
    itemsToShow: number;
}

export interface IOwnProps {
    handlePageSize?: any;
    searchText: string;
    initialPageSize?: number;
    pageSizeOnLoad: number;
    pageNumber?:string;
    setPageNumberToZero?: () => void;
}

const StyledDiv = styled.div`{
    display: inline-flex;
}`
type ResultProps = IStateProps & IPanelProps<any> & IOwnProps;
class PageSize extends React.Component<ResultProps, {actions: typeof pageSizeActions}> {
  
    public constructor(props) {
		super(props);
	}

    private handleChange = (val:number) => {
        if(this.props.pageNumber) {
            this.props.setPageNumberToZero();
        }
        this.props.actions.updatePageSize(val); // set pagesize in redux store for Learning page
        if(this.props.initialPageSize) {
            this.props.handlePageSize(val); // set pagesize on courselist on selection from dropdown
        }
    }

    public componentWillUnmount() {
        this.props.actions.updatePageSize(null);
    }

    public render () {
    return (
            <BlockView viewKey="pagesize.dropdown">
                <Label k="pageSize.label" v="Items per page:" />
                <StyledDiv>
                    <DropdownSelect
                        buttonProps={{
                            minimal: true,
                            small: true,
                        }}
                        options={pageSizeOptions}
                        value={this.props.itemsToShow || this.props.pageSizeOnLoad}
                        onChange={this.handleChange}
                    />
                </StyledDiv>
            </BlockView>
    )
}	
}

const mapStateToProps = (state) => {
    return {
        itemsToShow: state.pageSize.itemsToShow
    }
};

const mapDispatchToProps = (dispatch) => {
	return { actions: bindActionCreators(pageSizeActions as any, dispatch) };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageSize);



// WEBPACK FOOTER //
// ./src/common/fragments/PageSize.tsx